export const GOOGLE_PROVIDER_ID = true;
export const FACEBOOK_PROVIDER_ID = false;

/**
 * Returns output messages based on error codes
 * @param error Code of error 
 */
export const firebaseLoginErrors = (error) => {
    switch(error){
        case "auth/email-already-in-use":
            return "There is already an account with that email address."
        case "auth/weak-password":
            return "Your password is not strong enough!"
        case "auth/invalid-email":
            return "Invalid email address!"
        case "auth/user-disabled":
            return "Your account has been disabled."
        case "auth/user-not-found":
            return "There is no such user with that email address."
        case "auth/wrong-password":
            return "Wrong password! Please double check your credentials."
        case "auth/account-exists-with-different-credential":
            return "An account already exists with the same email address but different sign-in method. Sign in using a provider associated with this email address."
        default:
            return "Could not log you in at this time. Please check your credentials."
    }
}


// WEBPACK FOOTER //
// ./src/views/Register/constants.js